import React from 'react';
import { Home, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="max-w-4xl mx-auto px-6">
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-12 max-w-lg">
          <div className="text-8xl font-bold text-blue-600 mb-4">
            404
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            {t('errors.pageNotFound')}
          </h1>
          
          <p className="text-gray-600 mb-8 leading-relaxed">
            {t('errors.pageNotFoundMessage')}
          </p>
          
          <div className="flex gap-4 justify-center flex-wrap">
            <button
              onClick={handleGoHome}
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Home size={20} className="mr-2" />
              {t('common.goHome')}
            </button>
            
            <button
              onClick={handleGoBack}
              className="inline-flex items-center px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
            >
              <ArrowLeft size={20} className="mr-2" />
              {t('common.goBack')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;